var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getIcon,{tag:"component",staticClass:"svg",class:`${_vm.color} ${_vm.classMod}`,attrs:{"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }